import React, { useState, useEffect } from "react";
import {
  Container,
  Button,
  TextField,
  Toolbar,
  Backdrop,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom"; // Also import useLocation
import routes from "../../Config/routes.js";
import ConsentForm from "./popups/consentform.js";
import { buildGoogleAuthUrl } from '../Utils/googleAuthUrl';
import BlitzHeader from "../../Components/BlitzHeader.js";
import { useMutation, useQuery } from "react-query";
import API from "../../API/index.js";
import AlertDialog from "../../Components/AlertDialog.js";
import useAlertDialog from "../../Components/useAlertDialog.js";
import { toast } from 'sonner';

const CreatorConnectReatuh = () => {
  const navigate = useNavigate();
  const { creator } = useParams();
  const [consentOpen, setConsentOpen] = useState(false);
  const { mutate, isLoading } = useMutation({ mutationFn: API.creatorConnect.reauth, mutationKey: ['creatorConnect', 'reauth'] });
  const [waitGoogle, setWaitGoogle] = useState(false);
  const { data, isLoading: reauthDataLoading } = useQuery({
    queryKey: ['reauth', creator],
    queryFn: () => API.creatorConnect.getReauth(creator),
    onError: (error) => {
      alert(`There was an error fetching this reauth request: ${error?.response?.data?.error ? error.response.data.error : error.message}`);
      return window.location.href = routes.base;
    },
    onSuccess: (data) => toast.success('Reauthorization data loaded', {
      description: `Username: ${data?.username}`
    }),
    refetchInterval: false,
    refetchOnWindowFocus: false
  })

  const { dialogState, openDialog, closeDialog } = useAlertDialog();

  const GMAIL_SCOPES = [
    'https://www.googleapis.com/auth/gmail.modify',
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/userinfo.email'
  ].join(' ');

  const REDIRECT_URI = 'https://www.useblitz.co/creatorconnect/redirect';

  const handleConsentClose = (consented) => {
    setConsentOpen(false);
    if (consented) {
      mutate({ username: creator }, {
        onSuccess: (result) => {
          window.location.href = buildGoogleAuthUrl({
            state: result.request_id,
            redirectUri: REDIRECT_URI,
            scope: GMAIL_SCOPES,
            hint: data?.email || undefined,
          });
        },
        onError: (error) => {
          openDialog("Error", 
            `There was an error reauthorizating your Google account: ${error?.response?.data?.error ? error?.response?.data?.error : error.message}`,
          closeDialog, closeDialog, 'Ok', null);
        }
      });
    }
  };

  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading || waitGoogle || reauthDataLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <BlitzHeader>Authorize</BlitzHeader>
      <AlertDialog alertState={dialogState}></AlertDialog>
      <Toolbar></Toolbar>
      <Container maxWidth="md" sx={{ display: 'flex', gap: 2, flexDirection: 'column', alignItems: 'center', paddingBlockStart: 2 }}>
        <Typography variant="h4">Reauthorization for Partners</Typography>
        <TextField label="Creator Name" fullWidth value={data?.username || '...'} disabled />
        <Button variant="contained" color="primary" onClick={() => setConsentOpen(true)}>
          Reauthorize my Google Account
        </Button>
      </Container>

      <ConsentForm open={consentOpen} onClose={handleConsentClose} />
    </>
  );
};

export default CreatorConnectReatuh;
